import styled from '@emotion/styled';
import { gettext } from '@eventbrite/i18n';
import React from 'react';

const ProgressAnimation = styled.svg`
    animation: rotate 800ms linear infinite forwards;
`;

export const Progress = () => (
    <ProgressAnimation
        viewBox="0 0 100 100"
        role="progressbar"
        aria-valuetext={gettext('In progress').toString()}
        width="96px"
        height="96px"
    >
        <defs>
            <linearGradient id="stroke-large-thin-gradient-indeterminate">
                <stop offset="0%" stopColor="#4BE1A0"></stop>
                <stop offset="50%" stopColor="#4BE1A0"></stop>
                <stop offset="100%" stopColor="#4BE1A0" stopOpacity="0"></stop>
            </linearGradient>
        </defs>
        <path
            d="M93.5,50C93.5,74,74,93.5,50,93.5S6.5,74,6.5,50S26,6.5,50,6.5"
            stroke="url(#stroke-large-thin-gradient-indeterminate)"
            strokeWidth="2"
            strokeLinecap="round"
            shapeRendering="geometricPrecision"
            fill="none"
        ></path>
    </ProgressAnimation>
);
